<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close">
            <template #body>
                <div class="space-y-4 max-w-md mx-auto">
                    <div v-for="(email, index) in emails" :key="index" class="flex items-center gap-2">
                        <vs-input v-model="email.email" class="flex-1" />
                        <vs-button color="danger" icon="delete" @click="remove(index)" :disabled="emails.length === 1"
                            type="flat">
                            {{ $t('delete') | upperCase }}
                        </vs-button>
                    </div>
                        <vs-alert :active="alert">
                            Please check the email fields.
                        </vs-alert>
                </div>
             

            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="#195BFF" icon="add" type="flat" @click="add" :disabled="emails.length >= max">
                        {{ $t('add') | upperCase }}
                    </vs-button>
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="save">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed, getCurrentInstance } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    item: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['click', 'save', 'input'])

const emails = ref([])
const max = ref(5)
const { proxy } = getCurrentInstance()



watch(() => props.value, (newValue) => {
    if (newValue) {
        if (props.item && Array.isArray(props.item.emails)) {
            emails.value = props.item.emails.length === 0
                ? [{ email: '' }]
                : [...props.item.emails]
        } else {
            emails.value = [{ email: '' }]
        }
    }
})
const alert = computed(() => !validateEmails())

const close = () => {
    emit('input', false)
}

const add = () => {
    if (emails.value.length >= max.value) return
    emails.value.push({ email: '' })
}

const validateEmails = () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  
  const allValid = emails.value.every(e => {
    return e.email && e.email.trim() !== '' && emailRegex.test(e.email)
  })

  if (!allValid) return false

  const uniqueEmails = new Set(emails.value.map(e => e.email.trim().toLowerCase()))
  return uniqueEmails.size === emails.value.length
}


const remove = (index) => {
    if (emails.value.length === 1) return
    emails.value.splice(index, 1)
}

const save = () => {
    if (!validateEmails()) {
        proxy.$vs.notify({
            title: 'Invalid Data',
            text: 'Please check the email fields.',
            color: 'danger'
        })
        return
    }
    const filteredEmails = emails.value.filter(e => e.email && e.email.trim() !== '')
    const data = { clientId: props.item.clientId, emails: filteredEmails }
    emit('save', data)
}
</script>

<style></style>